import { useReduxState } from 'hooks';
import { breakpoints } from 'styles';
import { Box } from 'components/common/box';
import { Owners } from 'components/common';
import { PublishedProductText } from 'components/common';
import {
  CourseCategories,
  CourseParticipantsChart,
  CourseTitleWithInfo
} from 'components/courses/common';

import { AnalyticsCourse } from './AnalyticsCoursesList';

interface Props {
  course: AnalyticsCourse;
}

const AnalyticsCoursesListCourse = ({ course }: Props) => {
  const { messages } = useReduxState();

  return (
    <div className="course">
      <Box>
        <div className="course-content">
          <div className="course-title">
            <CourseTitleWithInfo linkToCourseAdminPage={true} course={course}>
              <Owners owners={course.owners} style={{ marginRight: 10 }} />
              <PublishedProductText
                endDate={course.endDate as string}
                startDate={course.startDate as string}
              />
              <div className="course-categories">
                <CourseCategories categories={course.categories} />
              </div>
            </CourseTitleWithInfo>
          </div>

          <div className="course-stats">
            <div className="row-md row-center">
              <div className="col-min">
                <div className="current-stats">
                  <CourseParticipantsChart
                    chartId={`analytics-courses-current-participants-${course.id}`}
                    completionEnabled={course.completionEnabled}
                    numberOfCompleted={
                      course.stats.currentParticipantsCompleted
                    }
                    numberOfCompletionExpired={
                      course.stats.currentParticipantsCompletionExpired
                    }
                    numberOfCompletionExpiring={
                      course.stats.currentParticipantsCompletionExpiring
                    }
                    numberOfParticipants={course.stats.currentParticipants}
                    numberOfNotStarted={
                      course.stats.currentParticipantsNotStarted
                    }
                    numberOfStarted={course.stats.currentParticipantsStarted}
                    participantsLabel={messages.commonAccessCurrentParticipants}
                    participantsLabelDescription={
                      messages.analyticsCurrentParticipantsDescription
                    }
                  />
                </div>
              </div>

              <div className="col-min">
                <div className="all-time-stats">
                  <CourseParticipantsChart
                    chartId={`analytics-courses-all-participants-${course.id}`}
                    completionEnabled={course.completionEnabled}
                    numberOfCompleted={course.stats.allParticipantsCompleted}
                    numberOfCompletionExpired={
                      course.stats.allParticipantsCompletionExpired
                    }
                    numberOfCompletionExpiring={
                      course.stats.allParticipantsCompletionExpiring
                    }
                    numberOfParticipants={course.stats.allParticipants}
                    numberOfNotStarted={course.stats.allParticipantsNotStarted}
                    numberOfStarted={course.stats.allParticipantsStarted}
                    participantsLabel={messages.analyticsAllParticipants}
                    participantsLabelDescription={
                      messages.analyticsAllParticipantsDescription
                    }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Box>

      <style jsx>{`
        .course:not(:first-child) {
          margin-top: 20px;
        }
        .course-categories {
          flex-basis: 100%;
          margin-top: 5px;
        }
        @media (min-width: ${breakpoints.medium}px) {
          .course-content {
            align-items: center;
            display: flex;
          }
          .course-title {
            flex-grow: 1;
            min-width: 0;
            padding-left: 5px;
          }
          .course-stats {
            flex-shrink: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default AnalyticsCoursesListCourse;
